export enum Themes {
  BLUE = 'blue',
  PURPLE = 'purple',
  DARK = 'dark',
  DEFAULT = 'default',
}
